export const  availablePermissions = {
    "FAQ Management":true,
    "User Management":true,
    "CMS Management" :true,
    "Ticket Management":true,
    "Airdrop Management":true,
    "Category Management":true,
    "Auction Management" :true,
    "Subadmin Management":true,
    "Bid Package Management":true,
    "Email Template Management":true,
    "Watch Ads and Get Free Bid Management":true,
}